import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import Header from '../components/Header';
import StickyHeader from '../components/StickyHeader';
import Footer from '../components/Footer';
import HomeBanner from '../components/HomeBanner';
import LatestPost from '../components/LatestPost';
import Promotion from '../components/Promotion';
import River from '../components/River';
import { commonUrl } from './api/config';
import * as LIB from '../lib/common';
import Head from 'next/head';
import ChatbotWidget from '../components/ChatbotWidget';

/*
-This is the entry point the whole website
-For global css, edit in glocals.css
-Html head is in _document.js
  
Main Color
Blue    #0077AB, #3392BC, #66ADCD, #CCE4EE
Orange  #F39800, #F5AC33, #F8C166, #FDEACC
purple  #923F93, #A865A9, #BE8CBE, #E9D9E9
Gray    #000000, #333333, #666666, #CCCCCC
*/

export default function Home({ latestData, riverData, blogData, menuData, musicData, bttmData, videoData, homeBannerData }) {
    const [promotionData, setPromotionData] = useState([]);

    useEffect(() => {
        //init data
        updateViewCount();
        fetchPromotionData();
    }, [])

    const updateViewCount = async () => {
        await fetch(commonUrl.viewCount);
    }

    const fetchPromotionData = async () => {
        fetch(commonUrl.promotionBars, {
        }).then(response => response.json()
        ).then(data => {
            setPromotionData(data);
        });
    }

    //render Home page.
    return (
        <Layout>
            <Head>
                <title>錫安日報</title>
            </Head>
            <Header topicData={menuData} />
            <StickyHeader topicData={menuData} /> 
            <HomeBanner data={homeBannerData} />
            <LatestPost data={latestData.data} pageTitle={"最新文章"} topPath={'/news/pmt/最新文章'} topicID='pmt'/>
            <Promotion data={promotionData} row={0} topicID='pmt1'/>
            <River data={riverData.data} dates={riverData.dates} />
            <Promotion data={promotionData} row={1} topicID='pmt2'/>
            <LatestPost data={blogData.data} pageTitle={"BLOG"} topPath={'/topics/blo/Blog'} topicID='blo'/>
            <Promotion data={promotionData} row={2} topicID='pmt3'/>
            <LatestPost data={musicData.data} pageTitle={"音樂特輯"} topPath={'/news/mus/音樂特輯'} topicID='mus'/>
            <Promotion data={promotionData} row={3} topicID='pmt4'/>
            <LatestPost data={videoData.data} pageTitle={"影片"} topPath={'/news/vid/影片'} topicID='vid'/>
            <Promotion data={promotionData} row={4} topicID='pmt5'/>
            <ChatbotWidget />
            <Footer />
        </Layout>
    )
}

export async function getServerSideProps() {

  // Fetch data from external API
  const [latestRes, blogRes, riverRes, menuRes, musicRes, bttmRes, videoRes, homeBannerRes] = await Promise.all([
    fetch(commonUrl.promotion),
    fetch(commonUrl.blog),
    fetch(commonUrl.river),
    fetch(commonUrl.menu),
    fetch(commonUrl.music),
    fetch(commonUrl.bttm),
    fetch(commonUrl.video),
    fetch(commonUrl.homeBanner)
  ]);

  // Await all JSON responses
  const [latestData, blogData, riverData, menuData, musicData, bttmData, videoData, homeBannerData] = await Promise.all([
    latestRes.json(),
    blogRes.json(),
    riverRes.json(),
    menuRes.json(),
    musicRes.json(),
    bttmRes.json(),
    videoRes.json(),
    homeBannerRes.json()
  ]);

  // Pass data to the page via props
  return { props: { latestData, blogData, riverData, menuData, musicData, bttmData, videoData, homeBannerData } }
}


